import { render, staticRenderFns } from "./studentDetail.vue?vue&type=template&id=bd60fa7e&"
import script from "./studentDetail.vue?vue&type=script&lang=js&"
export * from "./studentDetail.vue?vue&type=script&lang=js&"
import style0 from "./studentDetail.vue?vue&type=style&index=0&id=bd60fa7e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports